import {
    // PRIMARY,
    // SECONDARY,
    // TERTIARY,
    MELOGY_WHITE,
    MELOGY_BLACK,
    MELOGY_BACKGROUND_2XLIGHT_GREY,
    MELOGY_BACKGROUND_GREY_80,
    // MELOGY_BACKGROUND_LIGHT_GREY,
    // MELOGY_BACKGROUND_MEDIUM_LIGHT_GREY,
} from "../style/colors"

export const logoColors = [
    // PRIMARY,
    // SECONDARY,
    // TERTIARY,
    MELOGY_WHITE,
    MELOGY_BLACK,
    MELOGY_BACKGROUND_2XLIGHT_GREY,
    MELOGY_BACKGROUND_GREY_80,
    // MELOGY_BACKGROUND_LIGHT_GREY,
    // MELOGY_BACKGROUND_MEDIUM_LIGHT_GREY,
]

// Detect iOS device
const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
           (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export const enterFullScreen = () => {
    // iOS doesn't support standard fullscreen API
    if (isIOS()) {
        // For iOS, we use a different approach - set app to standalone mode in viewport meta
        const metaViewport = document.querySelector('meta[name=viewport]');
        if (metaViewport) {
            // Save the original content to restore later if needed
            metaViewport.setAttribute('data-original-content', metaViewport.getAttribute('content'));
            metaViewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover');
        }
        
        // Add a class to the body for fullscreen styling
        document.body.classList.add('ios-fullscreen');
        return;
    }

    let elem = document.documentElement

    if (elem.requestFullscreen) {
        elem.requestFullscreen()
    } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen()
    } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen()
    } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen()
    }
}

export const exitFullScreen = () => {
    // iOS doesn't support standard fullscreen API
    if (isIOS()) {
        // Restore the original viewport meta content
        const metaViewport = document.querySelector('meta[name=viewport]');
        if (metaViewport && metaViewport.getAttribute('data-original-content')) {
            metaViewport.setAttribute('content', metaViewport.getAttribute('data-original-content'));
        }
        
        // Remove the fullscreen class
        document.body.classList.remove('ios-fullscreen');
        return;
    }

    if (document.exitFullscreen) {
        document.exitFullscreen()
    } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen()
    } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari & Opera */
        document.webkitExitFullscreen()
    } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen()
    }
}
